import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import {
  ResearchTypePracticeVM,
  ResearchTypePracticeFilterVM,
} from 'practice/view-models/research-type-practice';
import ListTypeRegister from 'practice/components/shared/list-type-register';
import ListTypeInitiative from '../../shared/list-type-initiative';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<ResearchTypePracticeVM>();

  const onChange = useEventCallback(
    (
      key: keyof ResearchTypePracticeFilterVM,
      value: ResearchTypePracticeFilterVM[keyof ResearchTypePracticeFilterVM]
    ) => {
      formContext.setFieldValue('filter', {
        ...(formContext.values?.filter || {}),
        [key]: value,
      });
    }
  );

  const handleListTypeRegisterChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeRegister', event.target.value);
  });

  const handleListTypeInitiativeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeInitiative', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Codice tipo pratica"
          aria-label="Codice tipo pratica"
          fullWidth
          id="code"
          name="code"
          value={formContext.values.filter?.code || ''}
          onChange={(event) => onChange('code', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypePracticeFilterVM>)?.code &&
            Boolean((formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)?.code)
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)?.code
          }
          inputProps={{
            maxLength: '3',
          }}
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <PmiTextField
          label="Descrizione tipo pratica"
          aria-label="Descrizione tipo pratica"
          fullWidth
          id="description"
          name="description"
          value={formContext.values.filter?.description || ''}
          onChange={(event) => onChange('description', event.target.value)}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypePracticeFilterVM>)
              ?.description &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)?.description
            )
          }
          helperText={
            (formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)?.description
          }
          inputProps={{
            maxLength: '100',
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListTypeRegister
          value={formContext.values?.filter?.typeRegister || ''}
          onChange={handleListTypeRegisterChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypePracticeFilterVM>)
              ?.typeRegister &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)
                ?.typeRegister
            )
          }
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ListTypeInitiative
          value={formContext.values?.filter?.typeInitiative || ''}
          onChange={handleListTypeInitiativeChange}
          error={
            (formContext.touched.filter as FormikTouched<ResearchTypePracticeFilterVM>)
              ?.typeInitiative &&
            Boolean(
              (formContext.errors.filter as FormikErrors<ResearchTypePracticeFilterVM>)
                ?.typeInitiative
            )
          }
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
